module.exports = __webpack_public_path__ + "media/images/btn_merge-a15b57522516cf9d1606431cb88a8fa1.gif";